<template>
  <v-container fluid>
    <v-row justify="center" align="center">
      <v-col cols="12" align="right">
        <v-btn
            color="primary"
            align="right"
            @click="openDialog"
        >
          Thêm danh mục
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="product_categories"
            :items-per-page="10"
            class="elevation-1"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item.id)">
              mdi-pencil
            </v-icon>
            <!--              <v-icon small class="mr-2" @click="reviewItem(item.id)">-->
            <!--                mdi-eye-->
            <!--              </v-icon>-->
            <v-icon small @click="deleteItem(item.id)">
              mdi-delete
            </v-icon>
          </template>

          <template v-slot:item.active="{ item }">
            <v-checkbox v-model="item.active" @change="active(item.id)"></v-checkbox>
          </template>
        </v-data-table>
      </v-col>

<!--      dialog-->
      <v-dialog
          v-model="dialog"
          persistent
          max-width="600"
      >
        <v-card class="rounded-lg">
          <v-card-title  class="d-flex justify-center">

          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                    background-color="#EDF2F7"
                    filled
                    :items="categories"
                    item-text="name"
                    item-value="id"
                    v-model="category_id"
                    label="Chọn danh mục"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    background-color="#EDF2F7"
                    filled
                    label="Số lượng phần tử hiện thị tối đa"
                    v-model="number_product"
                    placeholder="Nhập số lượng"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    background-color="#EDF2F7"
                    filled
                    label="Số lượng phần tử hiện thị trên 1 hàng"
                    v-model="number_product_on_row"
                    placeholder="Nhập số lượng"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    background-color="#EDF2F7"
                    filled
                    label="Số lượng phần tử hiện thị trên 1 hàng giao diện mobile"
                    v-model="number_product_on_row_mobile"
                    placeholder="Nhập số lượng"
                ></v-text-field>
              </v-col>
              <span class="mx-3 font-weight-bold text-decoration-underline text-h5">LINK</span>
              <v-col cols="12">
                <v-select
                    background-color="#EDF2F7"
                    filled
                    :items="types"
                    item-text="text"
                    item-value="id"
                    v-model="type"
                    label="Chọn loại link"
                ></v-select>
              </v-col>
              <v-col cols="12" v-show="type == 1">
                <v-select
                    background-color="#EDF2F7"
                    filled
                    :items="list_type"
                    item-text="text"
                    item-value="id"
                    v-model="select_type"
                    label="Chọn loại"
                ></v-select>
              </v-col>
              <v-col cols="12" v-show="type == 1">
                <v-autocomplete
                    background-color="#EDF2F7"
                    filled
                    :items="list_ids"
                    item-text="name"
                    item-value="slug"
                    v-model="object_id"
                    label="Chọn ID"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" v-show="type == 2">
                <v-text-field
                    background-color="#EDF2F7"
                    filled
                    label="Đường dẫn URL"
                    v-model="url"
                    placeholder="Nhập đường dẫn"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                text
                @click="dialog = false"
            >
              Hủy
            </v-btn>
            <v-btn v-if="is_edit"
                color="primary"
                text
                @click="update"
            >
              Lưu
            </v-btn>
            <v-btn
                v-else
                color="primary"
                text
                @click="addNew"
            >
              Lưu
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import {mapGetters} from "vuex";
import {GET_LIST_PRODUCT_CATEGORY, SAVE_PRODUCT_CATEGORY, UPDATE_PRODUCT_CATEGORY, DELETE_PRODUCT_CATEGORY, GET_DETAIL_PRODUCT_CATEGORY, SET_DETAIL_PRODUCT_CATEGORY} from "@/store/modules/configs";
import {GET_LIST_CATEGORY} from "@/store/modules/category";
import {GET_LIST_BRAND} from "@/store/modules/brand";
import {GET_LIST_TAG} from "@/store/modules/tag";

export default {
  data() {
    return {
      brand_slug:null,
      category_id:null,
      number_product:null,
      number_product_on_row:null,
      number_product_on_row_mobile:null,
      name_type: '',
      object_id:null,
      select_type: null,
      dialog:false,
      list_ids: [],
      type: null,
      types: [
        {
          id:1,
          text: 'Link theo loại'
        },
        {
          id:2,
          text: 'Link theo URL'
        },
      ],
      list_type: [
        {
          id: "category",
          text: 'category'
        },
        {
          id: "brand",
          text: 'brand'
        },
        {
          id: "tag",
          text: 'tag'
        },
      ],
      items:[
        {
          id: 1,
          desktop_photo_url: null,
          mobile_photo_url: null,
        },
        {
          id: 2,
          desktop_photo_url: null,
          mobile_photo_url: null,
        },
        {
          id: 3,
          desktop_photo_url: null,
          mobile_photo_url: null,
        },
      ],
      headers: [
        { text: 'STT', value: 'id' },
        { text: 'Danh mục', value: 'name' },
        { text: 'Số lượng', value: 'number_product' },
        { text: 'Actions', value: 'actions' },
      ],
      url:'',
      is_edit: false,
    };
  },
  watch:{
    product_category(val){
      if (val && val.type){
        this.category_id = val.category_id;
        this.number_product = val.number_product;
        this.number_product_on_row = val.number_product_on_row;
        this.number_product_on_row_mobile = val.number_product_on_row_mobile;
        this.type = val.type
        this.object_id = val.link.object_id ?? null;
        this.select_type = val.link.type ?? null;
        this.url = val.link.url;
      }
    },
    select_type(val){
      const _this = this;
      if (val == "category") {
        this.name_type = 'category';
        this.$store.dispatch(`${GET_LIST_CATEGORY}`).then((data)=>{
          if(data && data.data && data.data.length > 0) {
            _this.list_ids = data.data;
          } else {
            _this.list_ids = [];
          }
        });
      }
      if (val == "brand") {
        this.name_type = 'brand';
        this.$store.dispatch(`${GET_LIST_BRAND}`).then((data)=>{
          if(data && data.data && data.data.length > 0) {
            _this.list_ids = data.data;
          } else {
            _this.list_ids = [];
          }
        });
      }
      if (val == "tag") {
        this.name_type = 'tag';
        this.$store.dispatch(`${GET_LIST_TAG}`).then((data)=>{
          if(data && data.data && data.data.length > 0) {
            _this.list_ids = data.data;
          } else {
            _this.list_ids = [];
          }
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      product_categories: 'product_categories',
      product_category: 'product_category',
      categories: 'categories',
      brands: 'brands',
    })
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_PRODUCT_CATEGORY}`);
    await this.$store.dispatch(`${GET_LIST_CATEGORY}`);
    await this.$store.commit(`${SET_DETAIL_PRODUCT_CATEGORY}`,{});
  },
  methods:{
    async addNew(){
      this.updateLink();
      const _this = this;
      if (this.type == 2) {
        this.name_type = '';
        this.object_id = null;
      }
      if (this.type == 1){
        this.url='';
      }
      if (this.number_product == null || this.number_product_on_row == null || this.number_product_on_row_mobile == null ){
        let text = ''
        if (this.number_product == null) {
           text = 'Số lượng phần tử hiện thị tối đa';
        }
        if (this.number_product == null) {
          text = 'Số lượng phần tử hiện thị trên 1 hàng';
        }
        if (this.number_product == null) {
          text = 'Số lượng phần tử hiện thị trên 1 hàng giao diện mobile';
        }
        this.$toasted.error('Không được bỏ trống trường '+text, {
          duration:2000,
          position:'top-center'
        })
        return false
      }
      let data_product_category = {
        category_id:this.category_id,
        number_product:this.number_product,
        number_product_on_row: this.number_product_on_row,
        number_product_on_row_mobile: this.number_product_on_row_mobile,
        type: this.type,
        link: {
          brand_slug: this.brand_slug,
          type: this.name_type,
          object_id: this.object_id,
          url: this.url
        }
      }
      await this.$store.dispatch(`${SAVE_PRODUCT_CATEGORY}`,data_product_category).then((data)=>{
        if(data.status) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          _this.$store.dispatch(`${GET_LIST_PRODUCT_CATEGORY}`);
          this.dialog = false;
        }
      })
    },
    async update(){
      this.updateLink();
      const _this = this;
      if (this.type == 2) {
        this.name_type = '';
        this.object_id = null;
      }
      if (this.type == 1){
        this.url='';
      }
      if (this.number_product == '' || this.number_product_on_row == '' || this.number_product_on_row_mobile == '' ){
        let text = ''
        if (this.number_product == '') {
          text = 'Số lượng phần tử hiện thị tối đa';
        }
        if (this.number_product == '') {
          text = 'Số lượng phần tử hiện thị trên 1 hàng';
        }
        if (this.number_product == '') {
          text = 'Số lượng phần tử hiện thị trên 1 hàng giao diện mobile';
        }
        this.$toasted.error('Không được bỏ trống trường '+text, {
          duration:2000,
          position:'top-center'
        })
        return false
      }
      let data_product_category = {
        id: this.product_category.id,
        type: this.type,
        category_id:this.category_id,
        number_product:this.number_product,
        number_product_on_row: this.number_product_on_row,
        number_product_on_row_mobile: this.number_product_on_row_mobile,
        link: {
          brand_slug: this.brand_slug,
          type: this.name_type,
          object_id: this.object_id,
          url: this.url
        }
      }
      await this.$store.dispatch(`${UPDATE_PRODUCT_CATEGORY}`,data_product_category).then((data)=>{
        if(data.status) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          _this.$store.dispatch(`${GET_LIST_PRODUCT_CATEGORY}`);
          this.dialog = false;
        }
      })
    },
    async openDialog() {
      this.is_edit = false;
      this.category_id = null;
      this.number_product = null;
      this.number_product_on_row=null;
      this.number_product_on_row_mobile=null;
      this.select_type = null;
      this.type = null
      this.object_id = null;
      this.url = '';
      this.dialog = true
      await this.$store.commit(`${SET_DETAIL_PRODUCT_CATEGORY}`,{});
    },
    async editItem(id)
    {
      this.is_edit = true
      await this.$store.dispatch(`${GET_DETAIL_PRODUCT_CATEGORY}`,id).then((data)=>{
        if(data) {
          this.dialog = true;
        }
      })
    },
    async deleteItem(id){
      const _this = this;
      confirm('Bạn có chắc muốn xóa?') &&
      await this.$store.dispatch(`${DELETE_PRODUCT_CATEGORY}`,id).then(data=>{
        if(data && data.status === 1) {
          _this.$store.dispatch(`${GET_LIST_PRODUCT_CATEGORY}`);
        }
      })
    },
    updateLink(){
      this.brand_slug = null;
      if(this.select_type == "category"){
        let category = this.list_ids.find(item =>{
          return item.slug == this.object_id
        })
        console.log(category);
        this.brand_slug = category.brand_slug;
      }
    }
  }
};
</script>